import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "gfu-project-mini-wizard-wrapper" }
const _hoisted_2 = { class: "gfu-labels" }
const _hoisted_3 = { class: "_fo _flexcol _rounded--inherit" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_countdown_badge = _resolveComponent("countdown-badge")
  const _component_detect_overflow = _resolveComponent("detect-overflow")
  const _component_progress_overlay = _resolveComponent("progress-overlay")
  const _component_box = _resolveComponent("box")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_box, {
      class: _normalizeClass($options.boxClasses),
      main: true
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          ($options.isCrowdfundingOvertimeActive)
            ? (_openBlock(), _createBlock(_component_countdown_badge, {
                key: 0,
                theme: "urgent",
                class: "_ml-3",
                "campaign-end": $options.campaignEndToDate
              }, null, 8 /* PROPS */, ["campaign-end"]))
            : _createCommentVNode("v-if", true)
        ]),
        _createElementVNode("div", _hoisted_3, [
          _renderSlot(_ctx.$slots, "header"),
          _createVNode(_component_detect_overflow, {
            class: "gfu-project-mini-wizard__content",
            "data-qa": "mini-wizard-content"
          }, {
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "default")
            ]),
            _: 3 /* FORWARDED */
          }),
          _renderSlot(_ctx.$slots, "footer")
        ]),
        _createVNode(_component_progress_overlay, { visible: $props.isProcessing }, null, 8 /* PROPS */, ["visible"])
      ]),
      _: 3 /* FORWARDED */
    }, 8 /* PROPS */, ["class"])
  ]))
}